import React from 'react'
import '../styles/policy.css'
import Navbar from "../components/Navbar"
import Footer from '../components/Footer'
import Seo from "../components/Seo";

export const Terms = () => {
  return (
    <section>
      <Seo path="/terms" />
      <Navbar />
      <div className="term-container">
        <h1>Terms &amp; Conditions</h1>
        <article>
          <p>
            This website is operated by <b>Cloudare Technologies Private Limited</b> ("Cloudare",
            "we", "us" or "our"). Cloudare offers this website, including all information, tools and
            services available from it, to you, the user, conditioned upon your acceptance of all
            terms, conditions, policies and notices stated here.
          </p>
          <p>
            By visiting our site or engaging our services, you agree to be bound by the following
            terms and conditions ("Terms of Service", "Terms"), including any additional terms and
            policies referenced herein or available by hyperlink. These Terms apply to all users of
            the site, including browsers, prospective clients, clients and partners.
          </p>
          <p>
            Please read these Terms carefully before using our website. If you do not agree to all
            of these Terms, you may not access the website or use our services.
          </p>

          <h3>About Cloudare</h3>
          <p>
            Cloudare Technologies Private Limited is an information-technology services company
            providing ERP implementation and support (including Oracle, Zoho and Odoo), global
            e-invoicing and tax-compliance integration, software development, and IT staffing.
            We operate across India, the United Arab Emirates, the United States and Canada.
          </p>

          <h3>Services and engagements</h3>
          <p>
            The scope, deliverables, fees, timelines and commercial terms of any professional
            engagement are governed by a separate written agreement, statement of work or proposal
            signed between Cloudare and the client. In the event of any conflict between such an
            agreement and these Terms, the signed agreement prevails for that engagement.
          </p>
          <p>
            Information on this website is provided for general information only and does not
            constitute a binding offer, legal, tax or financial advice, or a guarantee of any
            specific outcome. E-invoicing and tax mandates change frequently; clients are
            responsible for confirming current obligations applicable to them.
          </p>

          <h3>Use of the website</h3>
          <p>
            You agree not to use the site for any unlawful purpose, to attempt to gain unauthorised
            access to our systems, to interfere with the site's operation, or to reproduce,
            duplicate or exploit any portion of the site without our express written permission.
          </p>

          <h3>Intellectual property</h3>
          <p>
            All content on this website — including text, graphics, logos and design — is the
            property of Cloudare or its licensors and is protected by applicable intellectual
            property laws. Third-party names, logos and trademarks shown on the site remain the
            property of their respective owners and are used for identification purposes only.
          </p>

          <h3>Limitation of liability</h3>
          <p>
            To the maximum extent permitted by law, Cloudare shall not be liable for any indirect,
            incidental or consequential damages arising from your use of, or inability to use, this
            website. The website is provided on an "as is" and "as available" basis.
          </p>

          <h3>Governing law</h3>
          <p>
            These Terms are governed by the laws of India, without regard to conflict-of-law
            principles. Engagement-specific agreements may specify a different governing law or
            jurisdiction, which will apply to that engagement.
          </p>

          <h3>Changes to these Terms</h3>
          <p>
            We reserve the right, at our sole discretion, to update, change or replace any part of
            these Terms by posting updates to this page. It is your responsibility to check this
            page periodically. Your continued use of the website following any changes constitutes
            acceptance of those changes.
          </p>

          <h3>Contact</h3>
          <p>
            Questions about these Terms of Service should be sent to us at <b>hello@cloudare.in</b>.
          </p>
        </article>
      </div>
      <Footer />
    </section>
  )
}
